/* ============================================================
   SINGSPACE ADMIN - SECTION PROFIL UTILISATEUR (Pro Max)
   ============================================================ */

import { Input } from '@/components/ui/input';
import { Camera, Mail, User } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { FieldGroup } from './FieldGroup';
import { SectionTitle } from './SectionTitle';

export function ProfileSection() {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <SectionTitle
        label="Mon Profil"
        description="Gérez vos informations personnelles et votre identité sur la plateforme SING."
      />

      <div className="bg-white rounded-xl border border-slate-100 p-6">
        {/* Avatar Upload */}
        <div className="flex items-center gap-6 pb-6 mb-6 border-b border-slate-100">
          <div className="relative">
            <div className="w-20 h-20 rounded-xl bg-[#00303c] text-white flex items-center justify-center text-2xl font-bold">
              {user?.name?.substring(0, 2).toUpperCase()}
            </div>
            <button className="absolute -bottom-1 -right-1 w-8 h-8 rounded-lg bg-[#00758d] text-white flex items-center justify-center hover:bg-[#00303c] transition-colors">
              <Camera size={16} />
            </button>
          </div>
          <div className="space-y-1">
            <h4 className="text-sm font-bold text-slate-900">Photo de profil</h4>
            <p className="text-xs text-slate-500">Recommandé : JPG ou PNG, min. 400x400px.</p>
          </div>
        </div>

        <FieldGroup label="Nom complet" hint="Votre identité officielle sur la plateforme.">
          <Input leftIcon={<User size={18} />} defaultValue={user?.name || ''} className="h-11 max-w-md" />
        </FieldGroup>

        <FieldGroup label="Email de session" hint="Utilisé pour la connexion et les alertes de sécurité.">
          <Input
            leftIcon={<Mail size={18} />}
            type="email"
            defaultValue={user?.email || ''}
            className="h-11 max-w-md"
          />
        </FieldGroup>
      </div>
    </div>
  );
}
